import React, {useEffect, useState, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

const TablePagination = ({total = 0, itemsPerPage = 10, currentPage = 1, onPageChange}) => {
    const [totalPages, setTotalPages] = useState(0);
    const {t} = useTranslation();

    const [pageNumberLimit, setPageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        if (total > 0 && itemsPerPage > 0) setTotalPages(Math.ceil(total / itemsPerPage));
    }, [total, itemsPerPage]);

    const handleClick = page => {
        onPageChange(page);
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const upperLimit = Math.min(currentPage + Math.floor(pageNumberLimit / 2), totalPages);
        const lowerLimit = Math.max(1, upperLimit - pageNumberLimit + 1);
        for (let i = lowerLimit; i <= upperLimit; i++) {
            pageNumbers.push(
                <li key={i}>
                    <a
                        onClick={() => handleClick(i)}
                        className={`flex items-center cursor-pointer justify-center px-3 h-8  ${
                            i === currentPage
                                ? 'text-blue-600 border border-gray-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white'
                                : 'leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'
                        }`}>
                        {i}
                    </a>
                </li>,
            );
        }
        return pageNumbers;
    };

    useEffect(() => {
        const newMaxPageNumberLimit = Math.min(totalPages, currentPage + Math.floor(pageNumberLimit / 2));
        const newMinPageNumberLimit = Math.max(1, newMaxPageNumberLimit - pageNumberLimit + 1);
        setMaxPageNumberLimit(newMaxPageNumberLimit);
        setMinPageNumberLimit(newMinPageNumberLimit);
    }, [currentPage, pageNumberLimit, totalPages]);

    const handlePrev = () => {
        debugger;
        if (currentPage <= 1) {
            return;
        } else {
            if (currentPage > 1 && (currentPage - 1) % pageNumberLimit === 0) {
                setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
                setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
            }
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage >= totalPages) {
            return;
        } else {
            if (currentPage + 1 > maxPageNumberLimit) {
                setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
                setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
            }
            onPageChange(currentPage + 1);
        }
    };

    const renderPrevButton = () => (
        <li
            className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => {
                // onPageChange(currentPage - 1);
                handlePrev();
            }}>
            <a
                href="#"
                className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-xl hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                {t('anterior')}
            </a>
        </li>
    );

    const renderNextButton = () => (
        <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`} onClick={handleNext}>
            <a
                href="#"
                className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-xl hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                disabled={currentPage === totalPages || totalPages === 0}>
                {t('proxima')}
            </a>
        </li>
    );

    return (
        <ul className="inline-flex -space-x-px text-sm h-8 mr-2 mb-2">
            {renderPrevButton()}
            {renderPageNumbers()}
            {renderNextButton()}
        </ul>
    );
};

export default TablePagination;
